import { Trans } from "react-i18next"

export default function StageChangedContent({ ownerChallenge }) {
  return (
    <Trans
      i18nKey="notifications.stageChangedFound"
      values={{ challenge: ownerChallenge?.name || "Deleted" }}
      components={{ b: <b /> }}
    />
  )
}
